/**
 * Creates an array of specified length by repeating elements from the source array if necessary.
 * @param array The source array to guarantee length for
 * @param length The desired length of the resulting array
 * @returns A new array of the specified length containing elements from the source array
 */
export function guaranteeArrayMinLength(array, length) {
    if (array.length === 0 || length <= 0) {
        return [];
    }
    if (array.length >= length) {
        return array;
    }
    return Array.from({ length }, (_, i) => array[i % array.length]);
}
